export default __webpack_public_path__ + "static/media/s2s_apply.7117ea33.png";